<div class="contenedor-spinner">
    <mat-progress-spinner
      [color]="color"
      [mode]="mode"
      [value]="value"
      diameter="120">
  </mat-progress-spinner>
  <span class="texto-cargando">Cargando...<br>Un momento por favor</span>
  </div>